module.exports = __webpack_public_path__ + "img/XSurfLog.9a0f338a.svg";